import './App.css';
import Login from './components/Login/Login';
import SignUp from './components/Login/SignUp';
import SelectPlan from './components/Login/CreateAccount/SelectPlan';
import AccountDetails from './components/Login/CreateAccount/AccountDetails';
import ArtistDetails from './components/Login/CreateAccount/ArtistDetails';
import PlanDetails from './components/PreLogin/Artists/PlanDetails';
import { Route, Routes, Redirect, Navigate } from 'react-router-dom'
import LandingPage from './components/PreLogin/Home/LandingPage';
import Artists from './components/PreLogin/Artists/Artists';
import Producers from './components/PreLogin/Producers/Producers';
import PassReset from './components/Login/ForgotPassword';
import Navbar from './components/Navbar/Navbar';
import ShowNavbar from './components/Navbar/ShowNavbar';
import Dashboard from './components/PostLogin/Dashboard/Dashboard';
import LabelDashboard from './components/LabelPostLogin/LabelDashboard';
import VerifyEmail from './components/Login/CreateAccount/VerifyEmail';
import MFALogin from './components/Login/CreateAccount/MFALogin';
import PaymentPage from './components/Login/CreateAccount/PaymentPage';
import { useTranslation, Trans } from 'react-i18next';
import WorldCollection from './components/PostLogin/Dashboard/PromoteYourself/WorldCollection';
import Monetize from './components/PreLogin/Monetization.js/Monetize';
import SupportForm from './components/PreLogin/Monetization.js/SupportForm';
import About from './components/PreLogin/About/About';
import Publishing from './components/PreLogin/Publishing/Publishing';
import FAQ from './components/PreLogin/FAQ';
import PrivacyPolicy from './components/PreLogin/PrivacyPolicy/PrivacyPolicy';
import TermsConditions from './components/PreLogin/TermsConditions/TermsConditions';
import Pricing from './components/PreLogin/Pricing/Pricing';
import LabelAndEnterprise from './components/PreLogin/LabelAndEnterprise/LabelAndEnterprise';
import "./fonts/ClashGrotesk-Variable.ttf";
import "./fonts/ClashGrotesk-Bold.woff";
import "./fonts/ClashGrotesk-Extralight.woff";
import "./fonts/ClashGrotesk-Light.woff";
import "./fonts/ClashGrotesk-Medium.woff";
import "./fonts/ClashGrotesk-Semibold.woff";
import "./fonts/ClashGrotesk-Regular.woff";
import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import Support from './components/PostLogin/Dashboard/Support/Support';


const languages = {
  en: { nativeName: 'English' },
  kr: { nativeName: 'Korean' }
};

function App() {
  const { t, i18n } = useTranslation();
  const [select, setSelect] = useState(0);
  const location = useLocation();


  const setNavbarstate = (data) => {
    setSelect(data)
  }

  useEffect(() => {
    window.history.scrollRestoration = 'manual';
  }, []);

  useEffect(() => {
    console.log(location.pathname)
    if (location.pathname === "/Artist") {
      setSelect(1)
    }
    if (location.pathname === "/Producer") {
      setSelect(2)
    }
    if (location.pathname === "/monetize") {
      setSelect(3)
    }
    if (location.pathname === "/about") {
      setSelect(4)
    }
  }, [])

  useEffect(() => {
    console.log("App update")
    console.log(location.pathname)
    if (location.pathname === "/Artist") {
      setSelect(1)
    }
    if (location.pathname === "/Producer") {
      setSelect(2)
    }
    if (location.pathname === "/monetize") {
      setSelect(3)
    }
    if (location.pathname === "/about") {
      setSelect(4)
    }
  }, [location.pathname])


  useEffect(() => {
    console.log("Select Refresh")
  }, [select])

  return (
    <div className="App" style={{ width: '100vw', textAlign: 'left' }}>
      <header >
        {/* <Routes>
          <Route path="/" element={<Login/>}/>
          <Route exact path="/Signup" element={<SignUp/>}/>
        </Routes> */}

      </header>
      <ShowNavbar>
        <Navbar navopt={select} />
      </ShowNavbar>

      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route exact path="/Login" element={<Login />} />
        <Route exact path="/mfa" element={<MFALogin />} />
        <Route exact path="/payment" element={<PaymentPage />} />
        <Route exact path="/PasswordReset" element={<PassReset />} />
        <Route exact path="/Signup" element={<SignUp />} />
        <Route exact path="/SelectPlan" element={<SelectPlan />} />
        <Route exact path="/AccountDetails" element={<AccountDetails />} />
        <Route exact path="/ArtistDetails" element={<ArtistDetails />} />
        <Route exact path="/Artist" element={<Artists />} />
        <Route exact path="/PlanDetails" element={<PlanDetails />} />
        <Route exact path="/Producer" element={<Producers />} />
        <Route exact path="/verify/email" element={<VerifyEmail />} />
        <Route exact path="/Dashboard/*" element={<Dashboard />} />
        <Route exact path="/worldcollection" element={<WorldCollection />} />
        <Route exact path="/publishing" element={<Publishing />} />
        <Route exact path="/monetize" element={<Monetize />} />
        <Route exact path="/about" element={<About />} />
        <Route exact path="/support" element={<SupportForm />} />
        <Route exact path="/faq" element={<FAQ />} />
        <Route exact path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route exact path="/termsconditions" element={<TermsConditions />} />
        <Route exact path="/help/*" element={<Support />} />
        <Route exact path="/pricing" element={<Pricing />} />
        <Route exact path="/label" element={<LabelAndEnterprise />} />
        {/* <Route exact path="/label" element={ <Producers/>}/> */}
        <Route exact path="/dashboard/label/*" element={<LabelDashboard />} />
      </Routes>
    </div>
  );
}

export default App;
